import React from 'react';
import propTypes from 'prop-types';

const VideoComponent = ({ videoSrcId, videoTitle, videoStyle }) => {
    return (
        <div className={videoStyle}>
            <iframe
            width="100%" 
            height="500"
            src={`https://www.youtube-nocookie.com/embed/${videoSrcId}?cc_load_policy=1`}
            title={videoTitle}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            />
        </div>
  )}

export default VideoComponent;

VideoComponent.propTypes = { 
    videoStyle: propTypes.string,
  }
VideoComponent.defaultProps = {
    videoStyle: ''
  }